module.exports = __webpack_public_path__ + "static/media/loginBG@3x.68c0abfd.png";